import { IAssignAirdropAddress } from './types';
import { authRequest } from 'api/axios';

export const assignAddressRequest = async (params: IAssignAirdropAddress): Promise<any> => {
  const { data } = await authRequest.post('/mine/assign-airdrop-address', params);
  return data;
};
